import React from 'react'
import classNames from 'classnames'

interface LogoProps {
    // 'full' = icon + wordmark (one image per color mode, swapped via CSS on data-bs-theme)
    // 'icon' = standalone icon, same in both modes
    variant?: 'full' | 'icon'
    className?: string
}

const Logo: React.FC<LogoProps> = ({
    variant = 'full',
    className
}) => {
    if (variant === 'icon') {
        return (
            <img
                src="/assets/img/evertel-icon.png"
                alt="Evertel"
                className={classNames('logo', className)}
            />
        )
    }

    return (
        <>
            <img
                src="/assets/img/evertel-logo-light-mode.png"
                width={309}
                alt="Evertel"
                className={classNames('logo logo-light', className)}
            />
            <img
                src="/assets/img/evertel-logo-dark-mode.png"
                width={309}
                alt="Evertel"
                className={classNames('logo logo-dark', className)}
            />
        </>
    )
}

export { Logo }
export type { LogoProps }
